export default __webpack_public_path__ + "static/media/detail_mobile_9_6.960f3eee.jpg";